// Mayo-specific character avatars
import female_20_50_black from "./female_20_50_black.svg";
import female_50_70_black from "./female_50_70_black.svg";
import female_70_black from "./female_70_black.svg";
import male_20_50_black from "./male_20_50_black.svg";
import male_50_70_black from "./male_50_70_black.svg";
import male_70_black from "./male_70_black.svg";
import white_man_middle from "./white_man_middle_1.svg";
import white_man_old from "./white_man_old.svg";
import white_man_young from "./white_man_young.svg";
import white_woman_middle from "./white_woman_middle.svg";
import white_woman_old from "./white_woman_old.svg";
import white_woman_young from "./white_woman_young.svg";

const mayoAvatars = {
  female_20_50_black,
  female_50_70_black,
  female_70_black,
  male_20_50_black,
  male_50_70_black,
  male_70_black,
  white_man_middle,
  white_man_old,
  white_man_young,
  white_woman_middle,
  white_woman_old,
  white_woman_young,
};

export default mayoAvatars;
